<template>
  <div
    v-if="l_error"
    class="cussoldetail"
  >
    <div
      class="alert-box f-column z-index_4"
      style="background: var(--clr-black-1-3)"
    >
      <div
        class="weight_700"
        v-html="$t('messages.oops_error')"
      ></div>
      <div
        class="text-grey"
        v-html="$t('messages.opps_error_sub')"
      ></div>
    </div>
  </div>

  <div
    v-else
    class="cussoldetail"
    :class="{ 'gw_loading no-events': l_loading }"
  >
    <div
      class="f-align-center gw_loading_text"
      style="gap: 0.5rem"
    >
      <div class="text-normal weight_700">
        <span
          v-if="$store?.getters?.user_has_flag?.('SOL_3WAY')"
          class="truncate text-medium"
          v-html="
            [...(l_item?.custom_tree?.players || [])]
              .sort((a, b) => sortByPosition(a.position, b.position))
              ?.map(p => getPlayerHtmlPosition(p.display_position))
              .join($t('solfigr.vs'))
          "
        ></span>
        <span
          v-else
          v-html="
            $t(`solfigr.oop_vs_ip`, {
              oop: getPlayerHtmlPosition(l_item.custom_tree.players[0].display_position),
              ip: getPlayerHtmlPosition(l_item.custom_tree.players[1].display_position),
            })
          "
        ></span>
      </div>

      <div
        v-if="l_item.board"
        class="d-flex no-events mr-auto"
      >
        <div
          v-for="card in getCards(l_item.board || '')"
          :key="card + 'streets'"
          style="--height: 1.75em; --value-size-increase: 0.9"
          :class="`poker-card poker-card_mini card_${card[1]}`"
        >
          <div class="card-value">
            {{ card[0] }}
          </div>
        </div>
      </div>
    </div>

    <SolfigrSummary
      class="mt-2"
      :formResult="l_item.custom_tree"
      :loading="l_loading"
      :namespace="namespace"
    >
    </SolfigrSummary>

    <div
      v-if="hasClose"
      class="mdi mdi-close icon_btn pa-1"
      style="position: absolute; top: 0.5rem; right: 0.5rem; z-index: 4"
      @click="$emit('close')"
    ></div>
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'
import SolfigrSummary from '@/components/ConfigureSolution/SolfigrSummary'
import customSolutionMock from '@/components/DataTables/v2/tables/CustomSolutionsHistoryList/customSolutionMock.json'
import { sortByPosition } from '@/helpers/helpers'

export default {
  name: 'CustomSolutionDetail',
  components: {
    SolfigrSummary,
  },
  mixins: [float_mix, format_mix],
  props: {
    namespace: { default: () => '' },
    item: Object,
    hasClose: { default: () => true },
    error: Boolean,
    loading: Boolean,
    detailId: String,
    hasBtns: { default: () => true },
    endpoint: { default: () => `poker/custom-solutions/history/` },
    apiVersion: { default: () => 'v1' },
  },
  emits: ['close', 'loaded'],
  data() {
    return {
      l_error: false,
      l_loading: false,
      l_item: customSolutionMock,
    }
  },
  created() {
    if (this.detailId && !this.item) {
      this.getItemDetail()
    } else {
      this.l_error = this.error
      this.l_loading = this.loading
      this.l_item = this.item
    }
  },
  methods: {
    sortByPosition,
    async getItemDetail() {
      this.l_loading = true
      this.l_error = false
      this.l_item = customSolutionMock

      const result = await this.$store.dispatch('api_call', {
        method: 'GET',
        endpoint: `${this.endpoint}${this.detailId}/`,
        apiVersion: this.apiVersion,
        hasCancel: false,
      })

      if (result?.response?.data) {
        const { data } = result.response
        // poker/custom-solutions/custom-trees/
        // poker/custom-solutions/user-solutions/
        // poker/custom-solutions/history/ -- sol obj appended
        this.l_item = data.solution || data
        if (!this.l_item.custom_tree) {
          // poker/custom-solutions/custom-trees/
          this.l_item.custom_tree = data
        }
        // console.log(this.l_item, data)
        this.l_loading = false
        this.$emit('loaded', { item: this.l_item })

        return
      }
      this.l_error = true
      this.l_loading = false
      this.$emit('loaded', { error: true })
    },
  },
}
</script>

<style lang="scss" scoped>
.cussoldetail {
  --solfigr-gap: 1rem;
  display: flex;
  position: relative;
  flex-direction: column;
  min-width: clamp(1px, 45rem, 100vw);
}
</style>
